import React, { useCallback, useEffect, useState } from 'react'
import { push } from 'connected-react-router'
import Modal from 'react-modal'
import { connect } from 'react-redux';
import {
    Header,
    Button,
    ErrorMark,
    // SubHeader
} from '../../components/RegularComponents'
import { applicationReviewSelect } from '../../redux/selector/applicationReviewSelector';
import BusinessContactDetail from './BusinessContactDetail';
import AddressForService from './AddressForService'
import AddressForFinancialRecords from "./AddressForFinancialRecords"
import LicenceHistoryDetails from './LicenceHistoryDetails'
import CriminalHistoryDetails from './CriminalHistoryDetails'
import WorkHistoryDetails from './WorkHistoryDetails'
import LicenceSuspensionDetails from './LicenceSuspensionDetails'
import AdditionalBranchDetails from './AdditionalBranchDetails'
import CompanyTrademark from './CompanyTrademark'
// import TrustAccount from './TrustAccount'
import SupportingDocuments from './SupportingDocuments'
import TopNavigationBar from "../TopNavigationBar"
import {
    // APPLICATION_MODE_NEW,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    DOCUMENT_CONTENT_TYPE_PDF,
    REQUEST_STATUS,
    ROUTE_PATH
} from "../../app/constants"
import Navigation from '../Navigation';
import { replaceUrlParams } from '../../app/utils'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import DocumentViewer from '../../components/DocumentViewer/DocumentViewer'
import { DocumentViewerFileNameLink, DownloadFileNameLink } from '../../components/DocumentViewer/DocumentFileComponent';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING } from '../../app/errors';
import { convertFileDataForUrl } from '../../app/documentUploadUtils';
import { fetchDocumentData } from '../../redux/slice/supportingDocumentsSlice';
import { setMortgageProperty } from '../../redux/slice/primaryAgencyApplicationSlice';
import { setAllNewBranchApplicationsProperty } from '../../redux/slice/additionalApplicationsSlice';
// import CheckBoxForm from '../../components/CheckBoxForm';

const AGENT_APPLICATION_PROPERTY = "userApplicationReviewComplete";

const ApplicationReview = (props) => {
    const { applicationReview, dispatch } = props
    const { applicationType, applicationMode } = props.match.params
    const { forChangeRequest } = props.location.state ?? false
    const [reviewDetails, setReviewDetails] = useState(applicationReview.reviewDetails)


    const notRegistered = !applicationReview?.companyRjscDetails?.businessEntity?.entityId

    const REVIEW_COMPONENT_KEYS = {
        BUSINESS_CONTACT: "businessContact",
        ADDRESS_FOR_SERVICE: "addressForService",
        ADDRESS_FOR_FINANCE: "addressForFinance",
        CRIMINAL_HISTORY: "criminalHistoryDetails",
        WORK_HISTORY: "workHistoryDetails",
        LICENCE_SUSPENSION: "licenceSuspensionDetails",
        ADDITIONAL_BRANCHES: "additionalBranches",
        SUPPORTING_DOCUMENTS: "supportingDocuments",
        COMPANY_TRADEMARK : "companyTrademark"
    }

    useEffect(() => {
        setReviewDetails(applicationReview.reviewDetails)
    }, [
        applicationReview.reviewDetails,
        setReviewDetails
    ])

    const [editComponent, setEditComponent] = useState(null)
    const [showEditDialog, setShowEditDialog] = useState(false)

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const MainSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{ borderColor: "#777", borderWidth: '3px' }}
            />
        )
    }

    const SubSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{
                    borderColor: "#0058a466",
                    borderWidth: '3px',
                    width: "60%",
                    marginLeft: "0px"
                }}
            />
        )
    }

    /*=== click handlers == */
    const handleEditBusinessContact = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT)
    }

    const handleEditAddressForService = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE)
    }

    const handleEditAddressForFinance = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE)
    }

    const handleCriminalHistoryListEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY)
    }

    const handleWorkHistoryListEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.WORK_HISTORY)
    }

    const handleLicenceSuspendedEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION)
    }

    const handleAdditionalBranchesEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES)
    }

    const handleSupportingDocumentsEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS)
    }

    const handleCompanyTrademarkEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.COMPANY_TRADEMARK)
    }

    /* */
    const convertSupportingDocumentDataComponentsForReview = (data) => {
        if (!data) {
            return null
        }

        let reviewData = {}

        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const files = data[key];

                if (!files
                    || !Array.isArray(files)
                    || !files.length) {
                    continue
                }
                let fileComponents = []

                files.forEach((file, index) => {

                    if (file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF) {
                        fileComponents.push(
                            <div style={{ maxWidth: "40rem", overflow: "hidden" }}>
                                <DocumentViewerFileNameLink
                                    id={"document-view-link-" + file.fileName}
                                    key={"document-view-link-" + file.fileName}
                                    file={file}
                                    onClick={() => {

                                        if (file.data) {
                                            let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                            setDocumentViewerDocument(fileDataUrl)
                                            setSelectedFile(file)
                                            setOpenDocumentViewer(true)
                                        } else {
                                            dispatch(fetchDocumentData(file.guid))
                                                .then(downloadFile => {
                                                    if(downloadFile) { 
                                                        let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                        setDocumentViewerDocument(fileDataUrl)
                                                        setOpenDocumentViewer(true)
                                                        setSelectedFile(downloadFile)
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.error(error)
                                                })
                                        }
                                    }}
                                />
                            </div>
                        )
                    } else {
                        fileComponents.push(
                            <DownloadFileNameLink
                                id={"download-link-" + file.fileName}
                                componentKey={"download-link-" + file.fileName}
                                file={file}
                            />
                        )
                    }

                    if (index < files.length - 1) {
                        fileComponents.push(<br />)
                    }
                })

                Object.defineProperty(reviewData, key, { value: fileComponents, writable: true, enumerable: true })
            }
        }

        return reviewData
    }

    const titleForComponent = (componentKey) => {
        switch (componentKey) {
            case REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT:
                return "Business contact for licensing inquiries and consumer complaints and compliance"
            case REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE:
                return "Address for service"
            case REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE:
                return "Address for financial records"
            case REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY:
                return "Criminal history"
            case REVIEW_COMPONENT_KEYS.WORK_HISTORY:
                return "Work history"
            case REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION:
                return "Licence suspension"
            case REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES:
                return "Additional branches"
            case REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS:
                return "Supporting documents"
            case REVIEW_COMPONENT_KEYS.COMPANY_TRADEMARK :
                return "Company trademark"
            default:
                return ""
        }
    }

    const canEditTrademarkName = useCallback(() => {
        if(applicationReview?.companyRjscDetails?.businessData?.businessOwner
            && applicationReview?.companyRjscDetails?.businessEntity?.businessName) {
                return false
            }
        return true
    }, [applicationReview])

    /* == render == */
    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar 
                            {...props} 
                            hideSaveAndExit={forChangeRequest} 
                />
                {forChangeRequest ? 
                (<div className="row topMarginMedium bottomMarginMedium">
                    <div className="col-lg-12 reviewHeader">
                        <span>{applicationReview?.businessName ?? ""}</span>
                    </div>
                    <div className="col-lg-12 reviewSubHeader">
                        <span>
                            {applicationReview?.companyRjscDetails?.businessData?.businessOwner ?? ""}
                        </span>
                    </div>
                </div>) : (<Header header={applicationReview.header} />)}

                <div className="timeline row bottomMarginMedium">
                    <ol>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">1</span>
                                <div className="bottomMarginNormal"><h3>Applicant information</h3></div>
                                <div className="bottomMarginNormal"><h4>Company information</h4></div>
                                <ReviewForm data={reviewDetails.businessEntityDetails} fullSize={true} />
                                <MainSeparator />
                                <div className="bottomMarginNormal"><h4>{notRegistered ? "Officials listed" : "Officials listed under RJSC" }</h4></div>
                                <div className="companyPeopeReviewForm">
                                    {reviewDetails.businessPeopleDetails.map((people) => {
                                        return (
                                            <div className="companyPeopeReviewFormItem">
                                                <ReviewForm data={people} />
                                            </div>
                                        )
                                    })}
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Company Trademark</h3>
                                        <ReviewForm data={reviewDetails.companyTrademarkDetails} />
                                    </div>
                                    {canEditTrademarkName() && 
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-company-trademark"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleCompanyTrademarkEdit}
                                        />
                                    </div>}
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Business contact for licensing inquiries</h3>
                                        <ReviewForm data={reviewDetails.businessContact} />
                                        <SubSeparator />
                                        <h3>Business contact for consumer complaints and compliance</h3>
                                        <ReviewForm data={reviewDetails.complianceOfficer} />
                                        <SubSeparator />
                                        <h3>Responsible agent</h3>
                                        <ReviewForm data={reviewDetails.responsibleAgent} />
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-business-contact"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditBusinessContact}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Address for service</h3>
                                        <ReviewForm data={reviewDetails.addressForService} />
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-address-for-service"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditAddressForService}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Address for financial records</h3>
                                        <ReviewForm data={reviewDetails.addressForFinance} />
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-address-for-finance"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditAddressForFinance}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">2</span>
                                <div><h3>Company officials</h3></div>
                                <div className="bottomMarginNormal"><h4>Criminal history</h4></div>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {
                                            reviewDetails.criminalHistoryListData.map((criminalData, index) => {
                                                return (
                                                    <div key={"criminal-history-data-" + index}>
                                                        <ReviewForm data={criminalData} />
                                                        {(index < reviewDetails.criminalHistoryListData.length - 1)
                                                            && <SubSeparator />}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleCriminalHistoryListEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                                <div className="bottomMarginNormal"><h4>Work history</h4></div>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {
                                            reviewDetails.workHistoryListData.map((workHistoryData, index) => {
                                                return (
                                                    <div key={"work-history-data-" + index}>
                                                        <ReviewForm data={workHistoryData} />
                                                        {(index < reviewDetails.workHistoryListData.length - 1)
                                                            && <SubSeparator />}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-work-history-list"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleWorkHistoryListEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">3</span>
                                <h3>Licence suspension</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        <ReviewForm data={reviewDetails.licenceSuspendedQuestion} />
                                        {
                                            reviewDetails.licenceSuspendedData.map((data, index) => {
                                                return (
                                                    <div key={"suspension-data" + index}>
                                                        <ReviewForm data={data} />
                                                        {(index < reviewDetails.licenceSuspendedData.length - 1)
                                                            && <SubSeparator />}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-licence-suspended"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleLicenceSuspendedEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">4</span>
                                <h3>Additional branches</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {
                                            reviewDetails.additionalBranches.map((data, index) => {
                                                return (
                                                    <div key={"additional-banch-data-" + index}>
                                                        <ReviewForm data={data} />
                                                        {(index < reviewDetails.additionalBranches.length - 1)
                                                            && <SubSeparator />}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-additional-branches"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleAdditionalBranchesEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content step-content-no-border col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">5</span>
                                <h3>Supporting documents</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {
                                            reviewDetails.supportingDocuments.map((data, index) => {

                                                const reviewData = convertSupportingDocumentDataComponentsForReview(data)

                                                return (
                                                    <div key={"supporting-docs-data-" + index}>
                                                        <ReviewForm data={reviewData} fullSize={true} />
                                                        {(index < (reviewDetails.supportingDocuments.length - 1))
                                                            && <SubSeparator />}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-supporting-documents"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleSupportingDocumentsEdit}
                                        />
                                    </div>
                                </div>
                                {/* <MainSeparator /> */}
                            </div>
                        </li>
                        {
                            // <li className="timeline-item col-md-12">
                            //     <div className="step-content step-content-no-border col-md-12 col-xs-12">
                            //         <span className="step-counter step-counter-circle">6</span>
                            //         <h3>Collectors</h3>
                            //         <div className="row">
                            //             <div className="col-lg-11 topMarginMedium">
                            //                 {reviewDetails.agents.map((agentApp, index) => {
                            //                     return (
                            //                         <div key={`${agentApp.id}-${index}`}>
                            //                             <CheckBoxForm 
                            //                                 id={`application-review-agent-${agentApp.id}`}
                            //                                 value={`${agentApp.id}`}
                            //                                 labelText={agentApp.contactName}
                            //                                 checked={true}
                            //                                 onCheckBoxChange={() => {
                            //                                     // handler
                            //                                 }}
                            //                             />
                            //                         </div>
                            //                     )
                            //                 })}
                            //             </div>
                            //         </div>
                            //     </div>

                            // </li>
                        }
                    </ol>
                </div>
                <div className="row bottomMarginMedium">
                    {!forChangeRequest ? (<div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                        <Button
                            showSpinner={!applicationSaveError &&
                                (applicationReview.applicationSavingRequestStatus
                                    === REQUEST_STATUS.IN_PROGRESS)}
                            id="save-business-licence-application-data"
                            buttonType="regular_primary"
                            text={"Save and next"}
                            onClick={() => {
                                setApplicationSaveError(false)

                                /* 
                                - The name might be misleading, but below function will save the 
                                said property for the primary agency application.
                                */
                                dispatch(
                                    setMortgageProperty({
                                        key: AGENT_APPLICATION_PROPERTY,
                                        value: true,
                                    })
                                );

                                dispatch(
                                    setAllNewBranchApplicationsProperty({
                                        key: AGENT_APPLICATION_PROPERTY,
                                        value: true,
                                    })
                                );
    
                                props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                                    .then(data => {
                                        let nextUrl = applicationReview.navigation.next
                                        if (applicationMode === APPLICATION_MODE_RENEW) {
                                            nextUrl = applicationReview.navigationRenewal.next
                                        }
                                        dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
                                    })
                                    .catch(err => {
                                        setApplicationSaveError(true)
                                    })
                            }}
                        />
                        {applicationSaveError && ErrorMark()}
                        {applicationSaveError && <div className="help-block topMarginNormal">
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>}
                    </div>) : (<div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                        <Button 
                            showSpinner={!applicationSaveError &&
                                (applicationReview.applicationSavingRequestStatus
                                    === REQUEST_STATUS.IN_PROGRESS)}
                            text={applicationMode === APPLICATION_MODE_RENEW ? "Submit renewal request" : "Submit change request"}
                            buttonType="regular_primary"
                            onClick={() => {
                                setApplicationSaveError(false)
                                props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                                    .then(data => {
                                        dispatch(push(replaceUrlParams(
                                            ROUTE_PATH.WELCOME, 
                                            applicationType, 
                                            applicationMode)))
                                    })
                                    .catch(err => {
                                        setApplicationSaveError(true)
                                    })
                            }}
                            id="submit-change-request-button"
                        />
                        {applicationSaveError && ErrorMark()}
                        {applicationSaveError && <div className="help-block topMarginNormal">
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>}
                    </div>)}
                    
                </div>

                <Modal
                    appElement={document.getElementById('root')}
                    isOpen={showEditDialog}
                    contentLabel="editDetailsDialog"
                    onRequestClose={() => { setShowEditDialog(false) }}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    className="modalDialogContent editDetailsModalDialog"
                    closeTimeoutMS={150}>
                    <div className="row">
                        <div className="col-11">
                            <div className="row">
                                <div className="col-12">
                                    <h2>{titleForComponent(editComponent)}</h2>
                                    <MainSeparator />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {editComponent === REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT &&
                                        <BusinessContactDetail
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />}
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE &&
                                        <>
                                            <AddressForService
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE &&
                                        <>
                                            <AddressForFinancialRecords
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === "licenceHistoryDetails" &&
                                        <>
                                            <LicenceHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY &&
                                        <>
                                            <CriminalHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === REVIEW_COMPONENT_KEYS.WORK_HISTORY &&
                                        <>
                                            <WorkHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION &&
                                        <>
                                            <LicenceSuspensionDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES &&
                                        <>
                                            <AdditionalBranchDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                    {/* {editComponent === "trustAccount" && 
                                            <>
                                                <TrustAccount 
                                                    viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT} 
                                                    onEditSave={() => setShowEditDialog(false)}
                                                    {...props}
                                                />
                                            </>
                                        } */}
                                    {editComponent === REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS &&
                                        <>
                                            <SupportingDocuments
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                     {editComponent === REVIEW_COMPONENT_KEYS.COMPANY_TRADEMARK &&
                                        <>
                                            <CompanyTrademark
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-1">
                            <div
                                className="closeButton pull-right"
                                onClick={() => {
                                    setShowEditDialog(false)
                                }}
                            >
                                <i className="fa fa-2x fa-times"></i>
                            </div>
                        </div>
                    </div>



                </Modal>

                <DocumentViewer
                    fileData={documentViewerDocument}
                    fileName={selectedFile?.filename}
                    isOpen={openDocumentViewer}
                    handleClose={() => setOpenDocumentViewer(false)}
                />

            </div>
        </>
    )
}

export default connect(applicationReviewSelect)(ApplicationReview)
